import React from 'react';
import styles from './PageHeader.module.scss';
import classNames from 'classnames';

const PageHeader = () => {
    return (
        <div className={styles['header']}>
            <div className={classNames(styles['bar'])}></div>
            <div className={styles['logo-wrapper']}>
                <img
                    src={`/assets/ahc_logo.png`}
                    width="45"
                    height="45"
                    className="d-inline-block align-top"
                    alt="Alignment Health Logo"
                />
                <span className="ps-2">Alignment Health Plan&reg;</span>
            </div>
        </div>
    );
};

export default PageHeader;
